import React, { useState, useContext } from 'react';
import Layout from "components/Layout";
import FormLostPass from 'components/FormLostPass';
import FormVerification from 'components/FormVerification';
import FormChangePass from 'components/FormChangePass';
import FormResendCode from 'components/FormResendCode';
import LoginService from 'services/Login/service';
import SessionFactory from 'factories/Session';
import { AuthContext } from '../../auth/AuthContext';
import { types } from '../../types/types';
import PopupLayout from 'components/PopupLayout';
import PopupUpdateUser from 'components/PopupUpdateUser';

const LostPassword = () => {

    const { sessionDispatch } = useContext(AuthContext);
    const [formProcess, setFormProcess] = useState(1);
    const [formData, setFormData] = useState({});
    const changeFormProcess = (nextStep, data) => {
        setFormProcess(nextStep);
        setFormData(data);
    }
    const [loginValidation, setLoginValidation] = useState(false);  // Nuevo estado para almacenar el valor de validate
    const [loginDataValidation, setLoginDataValidation] = useState(); 

    const openPopupUpdateUser= () =>{
        //open popup band title end text de checkbox
   
  
        setLoginValidation(!loginValidation);
        console.log("validate login",loginValidation);
       

    }

    const processConfirmation = async (tokenData = '', onSuccess = null, onError = null) => {
        try{
            const encrypter_pass = await LoginService.authEncrypter({ 'password': formData.password });
            //reset - login vtex
            const reset_pass = await LoginService.authResetPass({ 
                'token': tokenData, 
                'email': formData.email, 
                'password': encrypter_pass.payload 
            });
            if(!reset_pass || (reset_pass && !reset_pass.payload) || (reset_pass && reset_pass.internalCode!=='200')){
                onError && onError();
                return;
            }
            //login application
            Promise.all([LoginService.authTokenCoupons({
                'jwt': reset_pass.payload.tokenJwt,
                'sessionType':"login"
            })]).then(auth => {
                SessionFactory.saveUpdateTries(auth[0].payload,'login');

                if(!auth || (auth && !['200','201'].includes(auth[0].internalCode))){
                    onError && onError();
                    return;
                }
                if(['200','201'].includes(auth[0].internalCode) && (!auth[0].payload.validateUserByDni)){
                    const loginData = {
                       loginApp: auth[0].payload,
                       login: reset_pass.payload.tokenJwt
                     };
                     setLoginDataValidation(loginData);
                     console.log(loginDataValidation);
                     setLoginValidation(true);//true indica que no tiene datos completos y se mostrar el popup
                     onSuccess && onSuccess();
                     return;
                   }
                onSuccess && onSuccess();
                sessionDispatch({
                    type: types.login,
                    payload: SessionFactory.initialize(auth[0].payload.additionalFields.jwt)
                });
            });
        }catch(error){
            console.error(error);
            onError && onError();
        }
    }

    return (
        <div className="lost-password">
            <Layout showBanner={false}>
                {formProcess===1
                    ?
                    <section className="authentication">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                    <div className="row">
                                        <div className="col-12">
                                            <h2 className="text-center red mt-4 mb-4">Restablecer contraseña</h2>
                                        </div>
                                        <div className="col-12 col-lg-6 col-xl-5 form form-1-column d-lg-flex flex-lg-column justify-content-lg-center ml-lg-auto mr-lg-auto">
                                            <FormLostPass processData={changeFormProcess}/>
                                        </div>
                                    </div>
                                    <div className="row footer-links">
                                        <div className="col-12 col-lg-4 ml-lg-auto mr-lg-auto mt-lg-5 mt-3">
                                            <p className="legend-login text-center">¿No tiene una cuenta? <a href="/register">Regístrese</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    (formProcess===2
                        ?
                        <section className="authentication">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                        <div className="row">
                                            <div className="col-12">
                                                <h2 className="text-center red mt-4 mb-4">Restablecer contraseña</h2>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-5 form form-1-column d-lg-flex flex-lg-column justify-content-lg-center ml-lg-auto mr-lg-auto">
                                                <FormChangePass processData={changeFormProcess} userData={formData}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        :
                        (formProcess===3
                            && 
                            <section className="authentication">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                            <div className="row">
                                                <div className="col-12">
                                                    <h2 className="text-center red mt-4 mb-4">Restablecer contraseña</h2>
                                                </div>
                                                <div className="col-12 col-lg-6 col-xl-6 form form-1-column d-lg-flex flex-lg-column justify-content-lg-center ml-lg-auto mr-lg-auto">
                                                    <FormVerification userEmail={formData && formData.email} externalSubmit={processConfirmation}/>
                                                </div>
                                            </div>
                                            <div className="row footer-links">
                                                <div className="col-12 col-lg-4 ml-lg-auto mr-lg-auto mt-lg-5 mt-3">
                                                    <FormResendCode userEmail={formData && formData.user} isRegister={false}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )
                    )
                }
            </Layout>
            <PopupLayout isShowwing={loginValidation} showingCallback={openPopupUpdateUser}>
                <PopupUpdateUser execActionConfirm={openPopupUpdateUser} titleText={"Actualizacion de Datos"} popupLegalText={"update"} loginData={loginDataValidation}  />
            </PopupLayout>
        </div>
    )
};

export default LostPassword;
